<template>
  <ul class="nav nav-mobile-menu">
<!--     <li>
      <md-field>
        <label>Search</label>
        <md-input v-model="search" type="text"></md-input>
      </md-field>
    </li>
    <li>
      <a href="#" class="dropdown-toggle" data-toggle="dropdown">
        <i class="material-icons">dashboard</i>
        <p>Stats</p></a
      >
    </li> -->
<!--     <li>
      <drop-down>
        <a slot="title" class="dropdown-toggle" data-toggle="dropdown">
          <i class="material-icons">language</i>
          <p>{{this.$lang.menu.language_change}}</p>
        </a>
        <ul class="dropdown-menu dropdown-menu-right">
          <li><a href="#" @click="changeLocation('sk')"><img src="/img/flags/sk.png" class="location-flag" />{{this.$lang.general.slovak}}</a></li>
          <li><a href="#" @click="changeLocation('en')"><img src="/img/flags/en.png" class="location-flag" />{{this.$lang.general.english}}</a></li>
        </ul>
      </drop-down>
    </li> -->
<!--     <li>
      <a href="#" data-toggle="dropdown" class="dropdown-toggle"
        ><i class="material-icons">person</i>
        <p>Account</p></a
      >
    </li> -->
  </ul>
</template>
<script>
export default {
  data() {
    return {

    };
  },
  computed: {
    getLocation() {
      return this.$store.getters.getLocation;
    }
  },
  methods: {
    changeLocation(location){
      this.$lang.setLang(location);
      this.$store.commit("setLocation", location);
    }
  }
};
</script>

<style lang="scss" scoped>

.location-flag {
  padding-right:10px;
}
</style>